import { renderContentWithMath } from '@helpers';
import { notionStore } from '@stores/notion.store';
import { RiskIndicatorType } from '@types';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import React from 'react';

import 'katex/dist/katex.min.css';
import { Tooltip } from '../Tooltip/Tooltip';

import styles from './RiskIndicatorTag.module.scss';

interface RiskIndicatorTagProps {
  indicator: RiskIndicatorType;
  className?: string;
  tooltipClassName?: string;
  disableTooltip?: boolean;
  animated?: boolean;
}

export const RiskIndicatorTag: React.FC<RiskIndicatorTagProps> = observer(
  ({ indicator, className, tooltipClassName, disableTooltip = false, animated }) => {
    const { values } = notionStore;

    if (!indicator) {
      return null;
    }

    const tag = (
      <span
        style={{ backgroundColor: indicator.color }}
        className={clsx(styles.card, className, animated && styles.animated)}
      >
        {/* <div className={styles.icon}>{indicator.icon}</div> */}
        <div className={styles.title}>{indicator.title}</div>
      </span>
    );

    if (disableTooltip || values === null || !values[indicator.title]) {
      return tag;
    }

    return (
      <Tooltip
        className={clsx(styles.tooltip)}
        tooltipClassName={tooltipClassName}
        hoverStyles={styles.cardStyles}
        content={<div dangerouslySetInnerHTML={{ __html: renderContentWithMath(values[indicator?.title]) }} />}
        placement="right"
        isFixed
      >
        {tag}
      </Tooltip>
    );
  },
);
